var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStackScss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sass") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,2A10,10,0,1,1,2,12,10,10,0,0,1,12,2M10,15.33a2.55,2.55,0,0,1,0,1.5c0,.05,0,.1-.06.17s0,.07-.07.12a2.5,2.5,0,0,1-.46.67c-.58.64-1.41.88-1.74.68s-.17-1.12.49-1.83a6.91,6.91,0,0,1,1.76-1.26h0l.08-.05m8.27-9c-.45-1.78-3.4-2.36-6.18-1.37A14,14,0,0,0,7.34,7.63c-1.53,1.44-1.78,2.69-1.68,3.21.34,1.84,2.88,3.05,3.92,3.94h0c-.3.15-2.54,1.28-3.08,2.44A1.62,1.62,0,0,0,7,19.45a3.16,3.16,0,0,0,3.41-1.38A3.44,3.44,0,0,0,10.75,15a4.34,4.34,0,0,1,1.53-.08c1.76.21,2.1,1.3,2,1.76a1.16,1.16,0,0,1-.55.79c-.12.07-.16.1-.15.16s.07.08.17.06a1.36,1.36,0,0,0,1-1.22c0-1.08-1-2.28-2.81-2.25a4.84,4.84,0,0,0-1.56.22l-.08-.09c-1.13-1.2-3.21-2-3.12-3.67,0-.59.23-2.13,4-4,3.08-1.54,5.55-1.12,6-.17.61,1.33-1.32,3.82-4.52,4.18a2.44,2.44,0,0,1-2-.51c-.17-.17-.19-.2-.25-.17s0,.23,0,.33a2,2,0,0,0,1.15.91,6.18,6.18,0,0,0,3.76-.37C17.2,10.12,18.72,8,18.27,6.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackScss);
export default __webpack_public_path__ + "static/media/stack_scss.3f9bb40decae595c949d69daf06f8a17.svg";
export { ForwardRef as ReactComponent };